import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RadioCardModel } from '../../../../core/models/radio-card.model';
import { RadioCardListModel } from '../../../../core/models/radio-card-list.model';
import { FormGroup } from '@angular/forms';
import { UtilsService } from '../../../services/utils/utils.service';
import { Numbers } from 'src/app/utils/constants';

@Component({
  selector: 'app-radio-card',
  templateUrl: './radio-card.component.html',
  styleUrls: ['./radio-card.component.scss']
})
export class RadioCardComponent implements OnInit {

  @Input() FORM_DATA: FormGroup;
  @Input() DATA_CONFIG: RadioCardListModel;

  @Output() clickCoverage: EventEmitter<{ radio: RadioCardModel, idx: number }> = new EventEmitter();
  pathFinish: string[];
  radioCardSelectable: RadioCardModel[] = [];
  insureSelected: string;
  isLegal = false;
  isListGaranties = false;
  particularTemporal = false;

  /**
   * @description constructor
   * @params utilsSrv
   */
  constructor(
    private utilsSrv: UtilsService
  ) {
    this.utilsSrv = utilsSrv;
  }
  /**
   * @description metodo inicio
   */
  ngOnInit() {
    this.pathFinish = [this.FORM_DATA.get('insureSelected').value.chosed, 'insuranceType'];
    this.insureSelected = this.FORM_DATA.get('insureSelected').value.chosed;
    this.setValueDefault();
  }
  /**
   * @description valor por defecto
   */
  setValueDefault(): void {
    let isPrevious = false;
    if (localStorage.getItem('prev-step2') !== null) { isPrevious = true; }
    let radiosDataL: any = null;
    // if (localStorage.getItem('radio-card') !== null) { radiosDataL = JSON.parse(localStorage.getItem('radio-card')); }
    if (sessionStorage.getItem('radio-card') !== null) { radiosDataL = JSON.parse(sessionStorage.getItem('radio-card')); }
    const INSURANCE_DURATION: any = this.FORM_DATA
      .get([this.FORM_DATA.get('insureSelected').value.chosed, 'insuranceDuration']).value;
    const LIST_GARANTIES: any = this.FORM_DATA.get([this.insureSelected, 'guaranteeSelectionList']).value;

    this.isListGaranties = false;
    if (LIST_GARANTIES.length > 0) { this.isListGaranties = true; }

    if (!isPrevious) {
      // Deseleccionamos todas las tarjetas
      this.DATA_CONFIG.radioCardList.forEach(e => {
        e.checked = false;
      });
      // Al entrar al paso eliminamos el tipo de seguro escogido
      this.FORM_DATA.get(this.pathFinish).setValue(null);
    } else {
      localStorage.removeItem('prev-step2');
    }

    // Ocio - Deporte - Particular
    const RADIO_CARD_TEMP: RadioCardModel = this.DATA_CONFIG.radioCardList.find(item => item.priority === 0);
    const RADIO_CARD_ANUAL: RadioCardModel = this.DATA_CONFIG.radioCardList.find(item => item.priority === 1);
    const RADIO_CARD_LONG_TIME: RadioCardModel = this.DATA_CONFIG.radioCardList.find(item =>
      item.priority === Numbers.number2);

    if (this.insureSelected === 'particularLegalAsistance' || this.insureSelected === 'ownerLegalAsistance') {
      this.setValueLegalDefault();
    } else if (this.insureSelected === 'incomingStudentsTravelAsistance') {
      this.setValueStudents();
    } else {
      this.isLegal = false;
      if (['form1.duration-temporal', 'form3.duration-temporal', 'Temporal', 'Temporary', RADIO_CARD_TEMP.title]
        .some((el: any) => el === INSURANCE_DURATION)) {
        RADIO_CARD_TEMP.checked = true;
        this.setValueTempDefault(RADIO_CARD_TEMP, RADIO_CARD_ANUAL, radiosDataL, isPrevious, INSURANCE_DURATION);
      } else {
        if (['form1.duration-anual', 'form3.duration-anual', 'Anual', RADIO_CARD_ANUAL.title]
          .some((el: any) => el === INSURANCE_DURATION)) {
            RADIO_CARD_ANUAL.checked = true;
            this.setValueAnualDefault(RADIO_CARD_ANUAL, RADIO_CARD_LONG_TIME, radiosDataL, isPrevious);
        }
        if (['form1.duration-long', 'form3.duration-long', 'Larga Estancia', 'Long stay', RADIO_CARD_LONG_TIME.title]
          .some((el: any) => el === INSURANCE_DURATION)) {
            RADIO_CARD_LONG_TIME.checked = true;
            this.setValueAnual90Default(RADIO_CARD_ANUAL, RADIO_CARD_LONG_TIME, radiosDataL, isPrevious);
        }
      }
      const SELECTION_IN_STEP_ONE: RadioCardModel = this.radioCardSelectable.find((item) => item.checked);
      this.FORM_DATA.get(this.pathFinish).setValue(SELECTION_IN_STEP_ONE);
      setTimeout(() => {
        const RADIOS_DATA: RadioCardModel[] = this.radioCardSelectable;
        sessionStorage.setItem('radio-card', JSON.stringify(RADIOS_DATA));
      }, Numbers.number700);
    }
  }

  /**
   * @description Asignación de datos para los formularios legales
   */
  setValueLegalDefault(): void {
    // Legal
    const RADIO_CARD_L1_TIME: RadioCardModel = this.DATA_CONFIG.radioCardList.find(item => item.priority === 0);
    const RADIO_CARD_L2_TIME: RadioCardModel = this.DATA_CONFIG.radioCardList.find(item => item.priority === 1);
    const AUX_TYPE_VALUE: any = this.FORM_DATA.get([this.insureSelected, 'insuranceType']).value;
    this.isLegal = true;
    if (AUX_TYPE_VALUE !== null && RADIO_CARD_L1_TIME.priority === AUX_TYPE_VALUE.priority) {
      RADIO_CARD_L1_TIME.checked = true;
    } else if (AUX_TYPE_VALUE !== null && RADIO_CARD_L2_TIME.priority === AUX_TYPE_VALUE.priority) {
      RADIO_CARD_L2_TIME.checked = true;
    } else {
      RADIO_CARD_L1_TIME.checked = true;
    }
    if (this.insureSelected === 'ownerLegalAsistance') {
      this.radioCardSelectable.push(RADIO_CARD_L1_TIME);
    } else {
      this.radioCardSelectable.push(RADIO_CARD_L1_TIME, RADIO_CARD_L2_TIME);
    }
    const SELECTION_IN_STEP_ONE: RadioCardModel = this.radioCardSelectable.find((item) => item.checked);
    this.FORM_DATA.get(this.pathFinish).setValue(SELECTION_IN_STEP_ONE);
  }

  /**
   * @description Asignación de datos para duración temporal
   */
  setValueTempDefault(radioCardTemp: any, radioCardAnual: any, radiosDataL: any, isPrevious: boolean, insuranceDuration: any): void {
    if (this.insureSelected === 'individualTravelAsistance' || (this.insureSelected === 'particularTravelAsistance' && insuranceDuration === 'Temporal')) {
      this.radioCardSelectable.push(radioCardTemp);
      if ( this.insureSelected === 'particularTravelAsistance') {
        this.particularTemporal = true;
      }
    } else if (!isPrevious) {
      this.radioCardSelectable.push(radioCardTemp, radioCardAnual);
    } else {
      this.radioCardSelectable.push(radiosDataL[0], radiosDataL[1]);
    }
  }

  /**
   * @description Asignación de datos para duración anual
   */
  setValueAnualDefault(radioCardAnual: any, radioCardLongTime: any, radiosDataL: any, isPrevious: boolean): void {
    if (!isPrevious) {
      this.radioCardSelectable.push(radioCardAnual, radioCardLongTime);
    } else {
      this.radioCardSelectable.push(radiosDataL[0], radiosDataL[1]);
    }
  }

  /**
   * @description Asignación de datos para duración larga duración
   */
  setValueAnual90Default(radioCardAnual: any, radioCardLongTime: any, radiosDataL: any, isPrevious: boolean): void {
    if (!isPrevious) {
      this.radioCardSelectable.push(radioCardAnual, radioCardLongTime);
    } else {
      this.radioCardSelectable.push(radiosDataL[0], radiosDataL[1]);
    }
  }

  /**
   * @description Asignación de datos para formulario de estudiantes
   */
  setValueStudents(): void {
    this.isLegal = false;
    const TYPE_STUDENTS: any = this.FORM_DATA.get([this.insureSelected, 'typeStudent']).value;
    let priorityS: number = Numbers.number0;
    if (TYPE_STUDENTS === 'nacional') {
      priorityS = Numbers.number2;
    } else if (TYPE_STUDENTS === 'Incoming') {
      priorityS = Numbers.number0;
    } else {
      priorityS = Numbers.number1;
    }
    const RADIO_CARD_STUDENT: RadioCardModel = this.DATA_CONFIG.radioCardList.find(item => item.priority === priorityS);
    this.radioCardSelectable.push(RADIO_CARD_STUDENT);
    RADIO_CARD_STUDENT.checked = true;
    const SELECTION_IN_STEP_ONE: RadioCardModel = this.radioCardSelectable.find((item) => item.checked);
    this.FORM_DATA.get(this.pathFinish).setValue(SELECTION_IN_STEP_ONE);
    setTimeout(() => {
      const RADIOS_DATA: RadioCardModel[] = this.radioCardSelectable;
      sessionStorage.setItem('radio-card', JSON.stringify(RADIOS_DATA));
    }, Numbers.number700);
  }

  /**
   * @description Es para comprobar que todos los inputs tienen datos para poder iniciar el componente
   */
  public checkDataCompOk(): boolean {
    return !!(this.FORM_DATA && this.DATA_CONFIG);
  }
  /**
   * @description actualizar datos
   * @params option
   * @params idx
   */
  public updateData(option: RadioCardModel, idx: number): void {
    if (!this.checkDataCompOk() || !this.radioCardSelectable) { return; }

    this.radioCardSelectable.forEach(e => e.checked = false);
    this.radioCardSelectable[idx].checked = true;

    // Actualizamos la duracion del seguro del paso 1
    if (!(this.insureSelected === 'particularLegalAsistance' || this.insureSelected === 'ownerLegalAsistance')) {
      this.FORM_DATA
        .get([this.FORM_DATA.get('insureSelected').value.chosed, 'insuranceDuration'])
        .setValue(this.utilsSrv.getTranslate(option.title));
    }
    // Actualizamos el tipo de seguro escogido
    this.FORM_DATA.get(this.pathFinish)
      .setValue(option);

    setTimeout(() => {
      sessionStorage.setItem('radio-card', JSON.stringify(this.radioCardSelectable));
    }, Numbers.number350);
  }
  /**
   * @description abrir cobertura
   * @params radio
   * @params idx
   */
  openCoverage(radio?: RadioCardModel, idx?: number): void {
    this.clickCoverage.emit({ radio, idx });
  }
  /**
   * @description tiene precios
   */
  hasPrices(): boolean {
    if (this.radioCardSelectable && this.radioCardSelectable.length > 0) {
      return true;
    }
  }

}
